import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_URL } from '../config';

function Subscribe() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // Call the backend API
      const response = await fetch(`${API_URL}/subscriptions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to subscribe');
      }
      
      // If successful, set submitted state and reset form
      setSubmitted(true);
      setEmail('');
      
      // If we have a preview URL (for development/testing)
      if (data.data?.previewUrl) {
        setPreviewUrl(data.data.previewUrl);
      }
    } catch (err) {
      setError(err.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      
      <main className="container">
        <section className="section">
          <h1>Subscribe to Our Newsletter</h1>
          <p>Stay updated with our latest tech insights, industry trends, and expert analysis.</p>
        </section>
        
        <section className="section">
          <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
            {submitted ? (
              <div className="subscribe-success">
                <h2>Thank You for Subscribing!</h2>
                <p>You've been added to our newsletter list.</p>
                <p>Check your email inbox for a confirmation message.</p>
                {previewUrl && (
                  <div className="preview-link">
                    <p>
                      <strong>Testing Mode:</strong> View your welcome email at:
                    </p>
                    <a 
                      href={previewUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="email-preview-link"
                    >
                      {previewUrl}
                    </a>
                  </div>
                )}
                <button 
                  className="read-more-button" 
                  onClick={() => {
                    setSubmitted(false);
                    setPreviewUrl('');
                  }}
                  style={{ marginTop: '1rem' }}
                >
                  Subscribe Another Email
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>                
                <div className="form-group">
                  <label htmlFor="email">Email Address*</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                    disabled={loading}
                  />
                </div>
                
                {error && <div className="error-message">{error}</div>}
                
                <div className="form-group">
                  <h3>Email Frequency</h3>
                  <div className="radio-group">
                    <label>
                      <input type="radio" name="frequency" defaultChecked /> Weekly
                    </label>
                  </div>
                </div>
                
                <button 
                  type="submit" 
                  className="read-more-button" 
                  style={{ width: '100%' }}
                  disabled={loading}
                >
                  {loading ? 'Subscribing...' : 'Subscribe to Newsletter'}
                </button>
                
                <p className="privacy-note">
                  We'll never share your email with anyone else. You can unsubscribe at any time.
                </p>
              </form>
            )}
          </div>
        </section>
        
        <section className="section">
          <h2>Why Subscribe?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <h3>Stay Informed</h3>
              <p>Get the latest updates on emerging technologies and industry trends.</p>
            </div>
            <div className="benefit-card">
              <h3>Learn Continuously</h3>
              <p>Access tutorials, best practices, and technical insights from our experts.</p>
            </div>
            <div className="benefit-card">
              <h3>Team Achievements</h3>
              <p>Discover what different teams are working on and their notable accomplishments.</p>
            </div>
            <div className="benefit-card">
              <h3>Software Architecture</h3>
              <p>Explore in-depth articles about architectural patterns and best practices.</p>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
}

export default Subscribe; 